import { PiniaPluginContext } from 'pinia';
import { Plugin } from '@nuxt/types';
import { ref, set } from '@nuxtjs/composition-api';
import StoreConfigGql from '~/plugins/query/StoreConfig.gql';
import type { StoreConfig } from '~/modules/GraphQL/types';

const storeConfigPlugin: Plugin = async ({ $pinia, app }) => {
  // Always determine storeCode based on device type
  const isMobile = app.$device && app.$device.isMobile;
  const storeCode = isMobile ? 'mobile' : 'vi';
  
  // Set the cookie for root path
  app.$cookies.set('vsf-store', storeCode, { path: '/' });
  
  // Also set for common API paths
  ['/v1/magento', '/v1/middleware'].forEach(path => {
    app.$cookies.set('vsf-store', storeCode, { path });
  });
  
  const { data }: { data: { storeConfig?: StoreConfig } } = await app.$vsf.$magento.api.customQuery({ 
    query: StoreConfigGql
  });

  $pinia.use(({ store }: PiniaPluginContext) => {
    if (store.$id !== 'magentoConfig') return;
    const storeConfig = ref(data?.storeConfig ?? {});

    // eslint-disable-next-line no-prototype-builtins
    if (!store.$state.hasOwnProperty('storeConfig')) {
      set(store.$state, 'storeConfig', storeConfig);
    } else {
      // eslint-disable-next-line no-param-reassign
      store.$state.storeConfig = storeConfig;
    }
  });
};

export default storeConfigPlugin;
